<script lang="ts">
	type Size = 'sm' | 'md' | 'lg'

	type Props = {
		label?: string
		value?: string | number
		maxValue?: number
		minValue?: number
		size?: Size
	}

	let {
		label,
		value = $bindable(0),
		maxValue = 1000000,
		minValue = 0,
		size = 'lg'
	}: Props = $props()

	const onHandleIncrement = () => {
		const numericValue = Number(value)
		if (numericValue < maxValue) {
			value = numericValue + 1
		}
	}

	const onHandleDecrement = () => {
		const numericValue = Number(value)
		if (numericValue > minValue) {
			value = numericValue - 1
		}
	}
</script>

<div class="stepper-wrapper">
	{#if label}
		<label class="stepper-label size-{size}">{label}</label>
	{/if}
	<div class="stepper size-{size}">
		<button class="stepper-button size-{size}" onclick={onHandleDecrement}>−</button>
		<div class="stepper-value size-{size}">{value}</div>
		<button class="stepper-button size-{size}" onclick={onHandleIncrement}>+</button>
	</div>
</div>

<style>
	.stepper-wrapper {
		@apply flex flex-col gap-2;
	}

	.stepper-label {
		@apply font-medium text-[#1c2b36];
	}

	.stepper-label.size-sm {
		@apply text-[12px];
	}

	.stepper-label.size-md {
		@apply text-[14px];
	}

	.stepper-label.size-lg {
		@apply text-[16px];
	}

	.stepper {
		@apply flex items-center border border-[#8aa0b4] overflow-hidden w-fit;
	}

	.stepper.size-sm {
		@apply rounded-[6px];
	}

	.stepper.size-md {
		@apply rounded-[10px];
	}

	.stepper.size-lg {
		@apply rounded-[12px];
	}

	.stepper-button {
		@apply text-[#5e7684] border-none bg-none cursor-pointer flex items-center justify-center;
	}

	.stepper-button.size-sm {
		@apply w-7 h-7 text-[14px];
	}

	.stepper-button.size-md {
		@apply w-10 h-10 text-[18px];
	}

	.stepper-button.size-lg {
		@apply w-12 h-12 text-[24px];
	}

	.stepper-button:hover {
		@apply bg-[#f0f4f7];
	}

	.stepper-value {
		@apply flex items-center justify-center text-[#1c2b36] border-l border-r border-[#8aa0b4];
	}

	.stepper-value.size-sm {
		@apply w-8 h-7 text-[12px];
	}

	.stepper-value.size-md {
		@apply w-12 h-10 text-[16px];
	}

	.stepper-value.size-lg {
		@apply w-16 h-12 text-[20px];
	}
</style>
